// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jQx09","big_text":"styles_big_text__-b9De","description":"styles_description__p6a1P","actions":"styles_actions__hzoVF"};